import { formatDate } from 'common/utils/dateUtils/date-utils';
import { ENDPOINTS_EMPLOYEE, ENDPOINTS_MANAGER } from 'common/endpoints/vacations-absences.endpoints';

class RemovePeriodService {

  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  removeRequest(employeeId, request, isInception, managerId) {
    let endDate = request.endDate === null ? null : formatDate(request.endDate);
    let config = {
      data: {
        startDate: formatDate(request.startDate),
        endDate: endDate,
        code: request.periodCode,
        remarks: request.remarks
      }
    };

    if (isInception) {
      return this.http.delete(ENDPOINTS_MANAGER.delete.request(employeeId, managerId), config);
    } else {
      return this.http.delete(ENDPOINTS_EMPLOYEE.delete.request(employeeId), config);
    }

  }
}

export default RemovePeriodService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRemovePeriod/removePeriod/removePeriod.service.js